import React from "react";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";

function ViewHistoryModal({ value, historyData }) {
    //   console.log("value", value);
    const historyRedeemAction = () => {
        console.log("history Redeem action performed here");
    };

    return (
        <div class="modal" id="ViewHistoryShowModal">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header" style={{ backgroundColor: "#46B9DD" }}>
                        <h4 class="modal-title">History </h4>
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
                    </div>

                    <div class="modal-body">
                        <h4 className="history-title">
                            {historyData?.PointsExpiryInfo?.PointsExpiryMessage}
                        </h4>
                        <div className="modal-reward-title"></div>
                        <div className="reward-desc-title">
                            <div className="ponts-main-wrap">
                                <div className="points-wrapper">
                                    <div className="title">
                                        {historyData?.PointsExpiryInfo?.PointsString}
                                    </div>
                                    {historyData?.PointsExpiryInfo?.PointsExpiryDate !==
                                        ("" || null) && (
                                            <div className="date">
                                                Expires on{" "}
                                                {historyData?.PointsExpiryInfo?.PointsExpiryDate}
                                            </div>
                                        )}
                                </div>
                                {historyData?.PointsExpiryInfo?.EnablePointsRedeemButton && (
                                    <button
                                        type="button"
                                        class="redeem-btn"
                                        onClick={() => historyRedeemAction()}
                                    >
                                        redeem
                                    </button>
                                )}
                                <hr />
                            </div>
                            {historyData?.PointsHistoryInfo?.map((eachHistory) => (
                                <div className="history-time">
                                    <div className="date">{eachHistory.PointsDateString}</div>
                                    {eachHistory.PointsInfo?.map((eachPoints) => (
                                        <div className="points-detail">
                                            <div className="points">{eachPoints.PointsString}</div>
                                            <span>{eachPoints.PointsTypeText}</span>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div class="modal-footer">
                        <Link to="#" data-dismiss="modal">
                            <button
                                className={`btn btn-success ${CONFIG.DATA.CARDENAS_UI ? `cardenasmarkets-border-radius` : ``
                                    }`}
                                style={{
                                    backgroundColor: "#22708F",
                                    color: "white",
                                }}
                            >
                                Cancel
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewHistoryModal;
